import UserOrderLog from './index';

export default { path: '/home/userOrderLog', component: UserOrderLog };
